import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { dateOptionsCriteria, organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_TRAVEL_PAST_POI_COUNT,
  FETCH_TRAVEL_PAST_POI_COUNT_ERROR,
  SET_TRAVEL_PAST_POI_COUNT
} from '../../constants';

const travelPastPoiCount = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_TRAVEL_PAST_POI_COUNT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/travel-past/poicount?${
          dateOptionsCriteria(state$, 'travelPast')
          }${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
          state$.value.travelPast.averageFilter
            ? `&average_filter=${encodeURIComponent(
              state$.value.travelPast.averageFilter
            )}`
            : ''
          }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_TRAVEL_PAST_POI_COUNT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_TRAVEL_PAST_POI_COUNT_ERROR,
            error,
          })
        )
      )
    )
  );

export default travelPastPoiCount;
